import { render, staticRenderFns } from "./TabTemplate.vue?vue&type=template&id=c054f8d4&scoped=true"
import script from "./TabTemplate.vue?vue&type=script&lang=js"
export * from "./TabTemplate.vue?vue&type=script&lang=js"
import style0 from "./TabTemplate.vue?vue&type=style&index=0&id=c054f8d4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c054f8d4",
  null
  
)

export default component.exports